import { ReactNode, useState } from 'react';
import ImagePreview from './image-preview';
import ImagePreviewShort from './image-preview-short';
import ImageGallery from './image-gallery';
import { VehicleImageWithMeta } from '@/catalog/types';
import assembleInteriorExteriorImageBuckets from '@/catalog/utils/pdp/validate-and-assemble-interior-exterior-image-buckets';
import HeroMissingImage from './hero-missing-image';

interface ImagePreviewContainerProps {
  images?: VehicleImageWithMeta[];
  cdnUrl: string;
  mobileInterstitialContent: ReactNode;
}

export default function ImagePreviewContainer({
  images,
  cdnUrl,
  mobileInterstitialContent,
}: ImagePreviewContainerProps) {
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [gallerySelectedImage, setGallerySelectedImage] = useState<string | undefined>(
    undefined
  );

  const {
    interiorImages = [],
    exteriorImages = [],
    galleryImages = [],
    heroImage,
  } = images && images.length > 0 ? assembleInteriorExteriorImageBuckets(images) : {};

  return (
    <>
      {images && images.length > 0 ? (
        <>
          <div className="hidden h-full lg:block">
            <ImagePreview
              interiorImages={interiorImages}
              exteriorImages={exteriorImages}
              heroImage={heroImage}
              cdnUrl={cdnUrl}
              onClickDelegate={(image) => {
                setGalleryOpen(true);
                setGallerySelectedImage(image);
              }}
            />
          </div>
          <div className="block lg:hidden">
            <ImagePreviewShort
              interiorImages={interiorImages}
              exteriorImages={exteriorImages}
              heroImage={heroImage}
              cdnUrl={cdnUrl}
              onClickDelegate={(image) => {
                setGalleryOpen(true);
                setGallerySelectedImage(image);
              }}
              interstitialContent={mobileInterstitialContent}
            />
          </div>

          <ImageGallery
            open={galleryOpen}
            images={galleryImages}
            interiorImages={interiorImages}
            exteriorImages={exteriorImages}
            cdnUrl={cdnUrl}
            selectedImage={gallerySelectedImage}
            onCloseDelegate={() => setGalleryOpen(false)}
          />
        </>
      ) : (
        <HeroMissingImage className="aspect-auto h-[400px] px-[16px] md:h-[680px] md:py-[16px]" />
      )}
    </>
  );
}
